import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { RootState } from './store';

const PrivetRoute = ({ element }) => {
  const { isLoggedIn, token } = useSelector((state: RootState) => state.auth);
  if (token && isLoggedIn) {
    return element;
  }
  return <Navigate to="/login" />;
};
export default PrivetRoute;
